import { render, staticRenderFns } from "./ArticleComments.pug?vue&type=template&id=63a307fe&lang=pug&external"
import script from "./ArticleComments.js?vue&type=script&lang=js&external"
export * from "./ArticleComments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports